// extracted by mini-css-extract-plugin
export var active = "hover-list-section-module--active--0OLlo";
export var element = "hover-list-section-module--element--U01It";
export var image = "hover-list-section-module--image--deS8I";
export var innerWrapper = "hover-list-section-module--inner-wrapper--L403f";
export var list = "hover-list-section-module--list--y4Vg1";
export var subtitle = "hover-list-section-module--subtitle--7qHPP";
export var text = "hover-list-section-module--text--X4GKG";
export var titlesContainer = "hover-list-section-module--titles-container--Pugsp";